import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface PricingHeroProps {
  className?: string;
}

const PricingHero = ({ className = '' }: PricingHeroProps) => {
  return (
    <section className={`relative py-20 lg:py-32 overflow-hidden ${className}`}>
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-transparent"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <Icon name="CurrencyEuroIcon" size={20} className="text-primary" />
            <span className="text-sm font-semibold text-primary">Transparante Prijzen</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-foreground mb-6">
            Investeer in de toekomst van uw bedrijf
          </h1>
          
          <p className="text-lg sm:text-xl text-muted-foreground mb-8 max-w-3xl mx-auto">
            Kies het pakket dat perfect past bij uw ambities. Geen verborgen kosten, alleen meetbare resultaten en een duidelijk rendement op uw investering.
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-card border border-border">
              <Icon name="CheckCircleIcon" size={20} className="text-success" />
              <span className="text-sm font-medium text-foreground">Geen setup kosten</span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-card border border-border">
              <Icon name="CheckCircleIcon" size={20} className="text-success" />
              <span className="text-sm font-medium text-foreground">Flexibele contracten</span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-card border border-border">
              <Icon name="CheckCircleIcon" size={20} className="text-success" />
              <span className="text-sm font-medium text-foreground">30 dagen geld terug</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingHero;